export const dictionary = {
  home: {
    title: "Uncover innovation trends",
    introduction:
      "As an IFIS Collections customer, you also benefit from access to our Trend Analytics tool. \nGain insight into food innovation trends through publication data drawn from FSTA, our comprehensive database for research in the sciences of food and heath.",
    categoriesTitle: "Research Areas",
    categoriesDescription:
      "Discover and compare global trends in food research by category and subcategory",
    keywordsTitle: "Keywords",
    keywordsDescription:
      "Explore the use of keywords in published research over time"
  }
};
